import { EXPAND_SHORTLINK, EXPAND_SHORTLINK_DONE, RESET_SHORTLINK } from './actionTypes';
export const expandShortlink = (data) => ({
    type: EXPAND_SHORTLINK,
    data
});
export const expandShortlinkDone = (data) => ({
    type: EXPAND_SHORTLINK_DONE,
    data
});
export const expandShortlinkError = (errorMessage) => ({
    type: 'EXPAND_SHORTLINK_ERROR',
    errorMessage
});
export const resetShortlink = () => ({
    type: RESET_SHORTLINK
});
//# sourceMappingURL=actionCreators.js.map